/**
 * types
 * 0 close combat
 * 1 ranged
 * 2 siege
 * 3 leader
 * 4 special (decoy)
 * 5 weather
 */

module.exports = {
  // "none": {
  //   name: "none",
  //   power: 0,
  //   ability: null,
  //   img: "foot_soldier1",
  //   faction: "northern",
  //   type: 0,
  //   collected: false
  // },
  "redanian_foot_soldier1": {
    name: "Redanian Foot Soldier",
    power: 1,
    ability: null,
    img: "foot_soldier1",
    faction: "northern",
    type: 0
    , collected: false
  },
  "redanian_foot_soldier2": {
    name: "Redanian Foot Soldier",
    power: 1,
    ability: null,
    img: "foot_solider2",
    faction: "northern",
    type: 0,
    collected: false
  },
  "poor_fucking_infantry1": {
    name: "Poor Fucking Infantry",
    power: 1,
    ability: "tight_bond",
    img: "infantry",
    faction: "northern",
    type: 0
    , collected: false
  },
  "poor_fucking_infantry2": {
    name: "Poor Fucking Infantry",
    power: 1,
    ability: "tight_bond",
    img: "infantry",
    faction: "northern",
    type: 0
    , collected: false
  },
  "poor_fucking_infantry3": {
    name: "Poor Fucking Infantry",
    power: 1,
    ability: "tight_bond",
    img: "infantry",
    faction: "northern",
    type: 0
    , collected: false
  },
  "yarpen_zigrin": {
    name: "Yarpen Zigrin",
    power: 2,
    ability: null,
    img: "yarpen",
    faction: "northern",
    type: 0
    , collected: false
  },
  "blue_stripes_commando1": {
    name: "Blue Stripes Commando",
    power: 4,
    ability: "tight_bond",
    img: "commando",
    faction: "northern",
    type: 0,
    collected: false
  },
  "blue_stripes_commando2": {
    name: "Blue Stripes Commando",
    power: 4,
    ability: "tight_bond",
    img: "commando",
    faction: "northern",
    type: 0,
    collected: false
  },
  "blue_stripes_commando3": {
    name: "Blue Stripes Commando",
    power: 4,
    ability: "tight_bond",
    img: "commando",
    faction: "northern",
    type: 0,
    collected: false
  },
  "sigismund_dijkstra": {
    name: "Sigismund Dijkstra",
    power: 4,
    ability: "spy",
    img: "dijkstra",
    faction: "northern",
    type: 0
    , collected: false
  },
  "prince_stennis": {
    name: "Prince Stennis",
    power: 5,
    ability: "spy",
    img: "stennis",
    faction: "northern",
    type: 0
    , collected: false
  },
  "siegfried_of_denesle": {
    name: "Siegfried of Denesle",
    power: 5,
    ability: null,
    img: "siegfried",
    faction: "northern",
    type: 0
    , collected: false
  },
  "ves": {
    name: "Ves",
    power: 5,
    ability: null,
    img: "ves",
    faction: "northern",
    type: 0
    , collected: false
  },
  "vernon_roche": {
    name: "Vernon Roche",
    power: 10,
    ability: "hero",
    img: "roche",
    faction: "northern",
    type: 0
    , collected: false
  },
  "john_natalis": {
    name: "John Natalis",
    power: 10,
    ability: "hero",
    img: "natalis",
    faction: "northern",
    type: 0
    , collected: false
  },
  "sheldon_skaggs": {
    name: "Sheldon Skaggs",
    power: 4,
    ability: null,
    img: "skaggs",
    faction: "northern",
    type: 1
    , collected: false
  },
  "sabrina_glevissig": {
    name: "Sabrina Glevissig",
    power: 4,
    ability: null,
    img: "sabrina",
    faction: "northern",
    type: 1
    , collected: false
  },
  "crinfrid_reavers_dragon_hunter1": {
    name: "Crinfrid Reaver's Dragon Hunter",
    power: 5,
    ability: "tight_bond",
    img: "crinfrid",
    faction: "northern",
    type: 1
    , collected: false
  },
  "crinfrid_reavers_dragon_hunter2": {
    name: "Crinfrid Reaver's Dragon Hunter",
    power: 5,
    ability: "tight_bond",
    img: "crinfrid",
    faction: "northern",
    type: 1
    , collected: false
  },
  "crinfrid_reavers_dragon_hunter3": {
    name: "Crinfrid Reaver's Dragon Hunter",
    power: 5,
    ability: "tight_bond",
    img: "crinfrid",
    faction: "northern",
    type: 1
    , collected: false
  },
  "sile_de_tansarville": {
    name: "Síle de Tansarville",
    power: 5,
    ability: null,
    img: "sile",
    faction: "northern",
    type: 1
    , collected: false
  },
  "keira_metz": {
    name: "Keira Metz",
    power: 5,
    ability: null,
    img: "keira",
    faction: "northern",
    type: 1
    , collected: false
  },
  "dethmold": {
    name: "Dethmold",
    power: 6,
    ability: null,
    img: "dethmold",
    faction: "northern",
    type: 1
    , collected: false
  },
  "kaedweni_siege_expert1": {
    name: "Kaedweni Siege Expert",
    power: 1,
    ability: "morale_boost",
    img: "siege_expert1",
    faction: "northern",
    type: 2
    , collected: false
  },
  "kaedweni_siege_expert2": {
    name: "Kaedweni Siege Expert",
    power: 1,
    ability: "morale_boost",
    img: "siege_expert2",
    faction: "northern",
    type: 2
    , collected: false
  },
  "kaedweni_siege_expert3": {
    name: "Kaedweni Siege Expert",
    power: 1,
    ability: "morale_boost",
    img: "siege_expert3",
    faction: "northern",
    type: 2
    , collected: false
  },
  "dun_banner_medic": {
    name: "Dun Banner Medic",
    power: 5,
    ability: "medic",
    img: "medic",
    faction: "northern",
    type: 2
    , collected: false
  },
  "ballista": {
    name: "Ballista",
    power: 6,
    ability: null,
    img: "ballista1",
    faction: "northern",
    type: 2
    , collected: false
  },
  "ballista2": {
    name: "Ballista",
    power: 6,
    ability: null,
    img: "ballista2",
    faction: "northern",
    type: 2
    , collected: false
  },
  "trebuchet1": {
    name: "Trebuchet (1 of 2)",
    power: 6,
    ability: null,
    img: "trebuchet1",
    faction: "northern",
    type: 2,
    collected: false
  },
  "trebuchet2": {
    name: "Trebuchet (2 of 2)",
    power: 6,
    ability: null,
    img: "trebuchet2",
    faction: "northern",
    type: 2
    , collected: false
  },
  "thaler": {
    name: "Thaler",
    power: 1,
    ability: "spy",
    img: "thaler",
    faction: "northern",
    type: 2
    , collected: false
  },
  "foltest_king_of_temeria": {
    name: "Foltest: King of Temeria",
    power: -1,
    ability: "foltest_leader1",
    img: "foltest_king",
    faction: "northern",
    type: 3
    , collected: false
  },
  "foltest_lord_commander": {
    name: "Foltest: Lord Commander",
    power: -1,
    ability: "foltest_leader2",
    img: "foltest_commander",
    faction: "northern",
    type: 3
    , collected: false
  },
  "foltest_siegemaster": {
    name: "Foltest: The Siegemaster",
    power: -1,
    ability: "foltest_leader3",
    img: "foltest_siege",
    faction: "northern",
    type: 3
    , collected: false
  },
  "foltest_forged": {
    name: "Foltest: The Steel-Forged",
    power: -1,
    ability: "foltest_leader4",
    img: "foltest_forged",
    faction: "northern",
    type: 3
    , collected: false
  },
  "philippa_eilhart": {
    name: "Philippa Eilhart",
    power: 10,
    ability: "hero",
    img: "eilhart",
    faction: "northern",
    type: 1
    , collected: false
  },
  "esterad_thyssen": {
    name: "Esterad Thyssen",
    power: 10,
    ability: "hero",
    img: "thyssen",
    faction: "northern",
    type: 0
    , collected: false
  },
  "siege_tower": {
    name: "Siege Tower",
    power: 6,
    ability: null,
    img: "siege_tower",
    faction: "northern",
    type: 2
    , collected: false
  },
  "catapult1": {
    name: "Catapult",
    power: 8,
    ability: "tight_bond",
    img: "catapult",
    faction: "northern",
    type: 2
    , collected: false
  },
  "catapult2": {
    name: "Catapult",
    power: 8,
    ability: "tight_bond",
    img: "catapult",
    faction: "northern",
    type: 2
    , collected: false
  },

  "emiel": {
    name: "Emiel Regis Rohellec Terzieff ",
    power: 5,
    ability: "none",
    img: "emiel",
    faction: "neutral",
    type: 0,
    collected: false
  },
  "geralt": {
    name: "Geralt of Rivia",
    power: 15,
    ability: "none",
    img: "geralt",
    faction: "neutral",
    type: 0,
    collected: false
  },
  "ciri": {
    name: "Cirilla Fiona Elen Rianno",
    power: 15,
    ability: "none",
    img: "ciri",
    faction: "neutral",
    type: 0,
    collected: false
  },
  "vesemir": {
    name: "Vesemir",
    power: 6,
    ability: "none",
    img: "vesemir",
    faction: "neutral",
    type: 0,
    collected: false
  },
  "triss_merigold": {
    name: "Triss Merigold",
    power: 7,
    ability: "none",
    img: "triss",
    faction: "neutral",
    type: 0,
    collected: false
  },
  "zoltan": {
    name: "Zoltan Chivay",
    power: 5,
    ability: "none",
    img: "zoltan",
    faction: "neutral",
    type: 0,
    collected: false
  },

  "yennefer": {
    name: "Yennefer of Vengerberg",
    power: 7,
    ability: "medic",
    img: "yen",
    faction: "neutral",
    type: 2,
    collected: false
  },
  "decoy": {
    name: "Decoy",
    power: -1,
    ability: "decoy",
    img: "decoy",
    faction: "neutral",
    type: 4
    , collected: false
  },
  "decoy2": {
    name: "Decoy",
    power: -1,
    ability: "decoy",
    img: "decoy",
    faction: "neutral",
    type: 4
    , collected: false
  },
  "decoy3": {
    name: "Decoy",
    power: -1,
    ability: "decoy",
    img: "decoy",
    faction: "neutral",
    type: 4
    , collected: false
  },
  "scorch": {
    name: "Scorch",
    power: -1,
    ability: "scorch_card",
    img: "scorch",
    faction: "neutral",
    type: 4
    , collected: false
  },
  "scorch2": {
    name: "Scorch",
    power: -1,
    ability: "scorch_card",
    img: "scorch",
    faction: "neutral",
    type: 4
    , collected: false
  },
  "scorch3": {
    name: "Scorch",
    power: -1,
    ability: "scorch_card",
    img: "scorch",
    faction: "neutral",
    type: 4
    , collected: false
  },
  "commanders_horn": {
    name: "Commander's Horn",
    power: -1,
    ability: "commanders_horn_card",
    img: "horn",
    faction: "neutral",
    type: 4
    , collected: false
  },
  "commanders_horn2": {
    name: "Commander's Horn",
    power: -1,
    ability: "commanders_horn_card",
    img: "horn",
    faction: "neutral",
    type: 4
    , collected: false
  },
  "commanders_horn3": {
    name: "Commander's Horn",
    power: -1,
    ability: "commanders_horn_card",
    img: "horn",
    faction: "neutral",
    type: 4
    , collected: false
  },
  "impenetrable_fog": {
    name: "Impenetrable Fog",
    power: -1,
    ability: "weather_fog",
    img: "fog",
    faction: "neutral",
    type: 5
    , collected: false
  },
  "impenetrable_fog2": {
    name: "Impenetrable Fog",
    power: -1,
    ability: "weather_fog",
    img: "fog",
    faction: "neutral",
    type: 5
    , collected: false
  },
  "impenetrable_fog3": {
    name: "Impenetrable Fog",
    power: -1,
    ability: "weather_fog",
    img: "fog",
    faction: "neutral",
    type: 5
    , collected: false
  },
  "biting_frost": {
    name: "Biting Frost",
    power: -1,
    ability: "weather_frost",
    img: "frost",
    faction: "neutral",
    type: 5
    , collected: false
  },
  "biting_frost2": {
    name: "Biting Frost",
    power: -1,
    ability: "weather_frost",
    img: "frost",
    faction: "neutral",
    type: 5
    , collected: false
  },
  "biting_frost3": {
    name: "Biting Frost",
    power: -1,
    ability: "weather_frost",
    img: "frost",
    faction: "neutral",
    type: 5
    , collected: false
  },
  "torrential_rain": {
    name: "Torrential Rain",
    power: -1,
    ability: "weather_rain",
    img: "rain",
    faction: "neutral",
    type: 5
    , collected: false
  },
  "torrential_rain2": {
    name: "Torrential Rain",
    power: -1,
    ability: "weather_rain",
    img: "rain",
    faction: "neutral",
    type: 5
    , collected: false
  },
  "clear_weather": {
    name: "Clear Weather",
    power: -1,
    ability: "weather_clear",
    img: "clear",
    faction: "neutral",
    type: 5
    , collected: false
  },
  "clear_weather2": {
    name: "Clear Weather",
    power: -1,
    ability: "weather_clear",
    img: "clear",
    faction: "neutral",
    type: 5
    , collected: false
  },

  "dandelion": {
    name: "Dandelion",
    power: 2,
    ability: "commanders_horn",
    img: "dandelion",
    faction: "neutral",
    type: 0
    , collected: false
  },
  "avallach": {
    name: "Avallac'h",
    power: 0,
    ability: ["hero", "spy"],
    img: "avallach",
    faction: "neutral",
    type: 0
    , collected: false
  },
  "villentretenmerth": {
    name: "Villentretenmerth ",
    power: 7,
    ability: "scorch",
    img: "villentretenmerth",
    faction: "neutral",
    type: 0
    , collected: false
  },

  "francesca_pureblood_elf": {
    name: "Francesca, Pureblood Elf",
    power: -1,
    ability: "francesca_leader1",
    img: "francesca_pureblood",
    faction: "scoiatael",
    type: 3
    , collected: false
  },
  "francesca_the_beautiful": {
    name: "Francesca The Beautiful",
    power: -1,
    ability: "francesca_leader2",
    img: "francesca_beautiful",
    faction: "scoiatael",
    type: 3
    , collected: false
  },
  "francesca_daisy_of_the_valley": {
    name: "Francesca, Daisy of The Valley",
    power: -1,
    ability: "francesca_leader3",
    img: "francesca_daisy",
    faction: "scoiatael",
    type: 3
    , collected: false
  },
  "francesca_queen_of_dol_blathanna": {
    name: "Francesca, Queen of Dol Blathanna",
    power: -1,
    ability: "francesca_leader4",
    img: "francesca_queen",
    faction: "scoiatael",
    type: 3
    , collected: false
  },
  "saesenthessis": {
    name: "Saesenthessis",
    power: 10,
    ability: "hero",
    img: "saesenthessis",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "iorveth": {
    name: "Iorveth",
    power: 10,
    ability: "hero",
    img: "iorveth",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "isengrim_faoiltiarnah": {
    name: "Isengrim Faoiltiarnah",
    power: 10,
    ability: ["hero", "morale_boost"],
    img: "isengrim",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "eithne": {
    name: "Eithne",
    power: 10,
    ability: "hero",
    img: "eithne",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "havekar_healer": {
    name: "Havekar Healer",
    power: 0,
    ability: "medic",
    img: "healer",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "havekar_healer2": {
    name: "Havekar Healer",
    power: 0,
    ability: "medic",
    img: "healer2",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "havekar_healer3": {
    name: "Havekar Healer",
    power: 0,
    ability: "medic",
    img: "healer3",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "riordain": {
    name: "Riordain",
    power: 1,
    ability: null,
    img: "riordain",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "toruviel": {
    name: "Toruviel",
    power: 2,
    ability: null,
    img: "toruviel",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "elven_skirmisher1": {
    name: "Elven Skirmisher",
    power: 2,
    ability: "muster",
    musterType: "skirmisher",
    img: "elven_skirmisher1",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "elven_skirmisher2": {
    name: "Elven Skirmisher",
    power: 2,
    ability: "muster",
    musterType: "skirmisher",
    img: "elven_skirmisher2",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "elven_skirmisher3": {
    name: "Elven Skirmisher",
    power: 2,
    ability: "muster",
    musterType: "skirmisher",
    img: "elven_skirmisher3",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "dwarven_skirmisher": {
    name: "Dwarven Skirmisher",
    power: 3,
    ability: "muster",
    musterType: "skirmisher",
    img: "skirmisher1",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "dwarven_skirmisher2": {
    name: "Dwarven Skirmisher",
    power: 3,
    ability: "muster",
    musterType: "skirmisher",
    img: "skirmisher2",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "dwarven_skirmisher3": {
    name: "Dwarven Skirmisher",
    power: 3,
    ability: "muster",
    musterType: "skirmisher",
    img: "skirmisher3",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "ciaran_aep_easnillien": {
    name: "Ciaran aep Easnillien",
    power: 3,
    ability: "agile",
    img: "easnillien",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "vrihedd_brigade_recruit": {
    name: "Vrihedd Brigade Recruit",
    power: 4,
    ability: null,
    img: "recruit",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "dol_blathanna_archer": {
    name: "Dol Blathanna Archer",
    power: 4,
    ability: null,
    img: "archer",
    faction: "scoiatael",
    type: 1
    , collected: false
  }, /*
  "hav_caaren_medic": {
    name: "Hav’caaren Medic",
    power: 5,
    ability: null,
    img: "", //missing image
    faction: "scoiatael",
    type: 0
,collected:false  
},*/
  "havekar_smuggler": {
    name: "Havekar Smuggler",
    power: 5,
    ability: "muster",
    musterType: "smuggler",
    img: "smuggler1",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "havekar_smuggler2": {
    name: "Havekar Smuggler",
    power: 5,
    ability: "muster",
    musterType: "smuggler",
    img: "smuggler2",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "havekar_smuggler3": {
    name: "Havekar Smuggler",
    power: 5,
    ability: "muster",
    musterType: "smuggler",
    img: "smuggler3",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "mahakaman_defender1": {
    name: "Mahakaman Defender",
    power: 5,
    ability: null,
    img: "defender1",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "mahakaman_defender2": {
    name: "Mahakaman Defender",
    power: 5,
    ability: null,
    img: "defender2",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "mahakaman_defender3": {
    name: "Mahakaman Defender",
    power: 5,
    ability: null,
    img: "defender3",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "mahakaman_defender4": {
    name: "Mahakaman Defender",
    power: 5,
    ability: null,
    img: "defender4",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "mahakaman_defender5": {
    name: "Mahakaman Defender",
    power: 5,
    ability: null,
    img: "defender5",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "vrihedd_brigade_veteran": {
    name: "Vrihedd Brigade Veteran",
    power: 5,
    ability: "agile",
    img: "veteran1",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "vrihedd_brigade_veteran2": {
    name: "Vrihedd Brigade Veteran",
    power: 5,
    ability: "agile",
    img: "veteran2",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "dennis_cranmer": {
    name: "Dennis Cranmer",
    power: 6,
    ability: null,
    img: "cranmer",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "filavandrel_aen_fidhail": {
    name: "Filavandrel aén Fidháil",
    power: 6,
    ability: "agile",
    img: "fidhail",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "ida_emean_aep_sivney": {
    name: "Ida Emean aep Sivney",
    power: 6,
    ability: null,
    img: "sivney",
    faction: "scoiatael",
    type: 1
    , collected: false
  },
  "yaevinn": {
    name: "Yaevinn",
    power: 6,
    ability: "agile",
    img: "yaevinn",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "barclay_els": {
    name: "Barclay Els",
    power: 6,
    ability: "agile",
    img: "barclay",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "dol_blathanna_scout1": {
    name: "Dol Blathanna Scout",
    power: 6,
    ability: "agile",
    img: "scout1",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "dol_blathanna_scout2": {
    name: "Dol Blathanna Scout",
    power: 6,
    ability: "agile",
    img: "scout2",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "dol_blathanna_scout3": {
    name: "Dol Blathanna Scout",
    power: 6,
    ability: "agile",
    img: "scout3",
    faction: "scoiatael",
    type: 0
    , collected: false
  },
  "milva": {
    name: "Milva",
    power: 10,
    ability: "morale_boost",
    img: "milva",
    faction: "scoiatael",
    type: 1
    , collected: false
  },


  "eredin_commander_of_the_red_riders": {
    name: "Eredin, Commander of the Red Riders",
    power: -1,
    ability: "eredin_leader1",
    img: "eredin_commander",
    faction: "monster",
    type: 3
    , collected: false
  },
  "eredin_bringer_of_death": {
    name: "Eredin, Bringer of Death",
    power: -1,
    ability: "eredin_leader2",
    img: "eredin_bringer",
    faction: "monster",
    type: 3
    , collected: false
  },
  "eredin_destroyer_of_worlds": {
    name: "Eredin, Destroyer of Worlds",
    power: -1,
    ability: "eredin_leader3",
    img: "eredin_destroyer",
    faction: "monster",
    type: 3
    , collected: false
  },
  "eredin_king_of_the_wild_hunt": {
    name: "Eredin, King of The Wild Hunt",
    power: -1,
    ability: "eredin_leader4",
    img: "eredin_king",
    faction: "monster",
    type: 3
    , collected: false
  },
  "kayran": {
    name: "Kayran",
    power: 8,
    ability: ["hero", "morale_boost", "agile"],
    img: "kayran",
    faction: "monster",
    type: 1
    , collected: false
  },
  "leshen": {
    name: "Leshen",
    power: 10,
    ability: "hero",
    img: "leshen",
    faction: "monster",
    type: 1
    , collected: false
  },
  "imlerith": {
    name: "Imlerith",
    power: 10,
    ability: "hero",
    img: "imlerith",
    faction: "monster",
    type: 0
    , collected: false
  },
  "draug": {
    name: "Draug",
    power: 10,
    ability: "hero",
    img: "draug",
    faction: "monster",
    type: 0
    , collected: false
  },
  "ghoul": {
    name: "Ghoul",
    power: 1,
    ability: "muster",
    musterType: "ghoul",
    img: "ghoul1",
    faction: "monster",
    type: 0
    , collected: false
  },
  "ghoul2": {
    name: "Ghoul",
    power: 1,
    ability: "muster",
    musterType: "ghoul",
    img: "ghoul2",
    faction: "monster",
    type: 0
    , collected: false
  },
  "ghoul3": {
    name: "Ghoul",
    power: 1,
    ability: "muster",
    musterType: "ghoul",
    img: "ghoul3",
    faction: "monster",
    type: 0
    , collected: false
  },
  "nekker": {
    name: "Nekker",
    power: 2,
    ability: "muster",
    musterType: "nekker",
    img: "nekker1",
    faction: "monster",
    type: 0
    , collected: false
  },
  "nekker2": {
    name: "Nekker",
    power: 2,
    ability: "muster",
    musterType: "nekker",
    img: "nekker2",
    faction: "monster",
    type: 0
    , collected: false
  },
  "nekker3": {
    name: "Nekker",
    power: 2,
    ability: "muster",
    musterType: "nekker",
    img: "nekker3",
    faction: "monster",
    type: 0
    , collected: false
  },
  "wyvern": {
    name: "Wyvern",
    power: 2,
    ability: null,
    img: "wyvern",
    faction: "monster",
    type: 1
    , collected: false
  },
  "foglet": {
    name: "Foglet",
    power: 2,
    ability: null,
    img: "foglet",
    faction: "monster",
    type: 0
    , collected: false
  },
  "celaeno_harpy": {
    name: "Celaeno Harpy",
    power: 2,
    ability: "agile",
    img: "celaeno_harpy",
    faction: "monster",
    type: 1
    , collected: false
  },
  "gargoyle": {
    name: "Gargoyle",
    power: 2,
    ability: null,
    img: "gargoyle",
    faction: "monster",
    type: 1
    , collected: false
  },
  "cockatrice": {
    name: "Cockatrice",
    power: 2,
    ability: null,
    img: "cockatrice",
    faction: "monster",
    type: 1
    , collected: false
  },
  "harpy": {
    name: "Harpy",
    power: 2,
    ability: "agile",
    img: "harpy",
    faction: "monster",
    type: 1
    , collected: false
  },
  "endrega": {
    name: "Endrega",
    power: 2,
    ability: null,
    img: "endrega",
    faction: "monster",
    type: 1
    , collected: false
  },
  "vampire_bruxa": {
    name: "Vampire: Bruxa",
    power: 4,
    ability: "muster",
    musterType: "vampire",
    img: "vampire_bruxa",
    faction: "monster",
    type: 0
    , collected: false
  },
  "vampire_katakan" :{
    name: "Vampire: Katakan",
    power: 4,
    ability: "muster",
    musterType: "vampire",
    img: "vampire_katakan",
    faction: "monster",
    type: 0
    , collected: false
  },
  "vampire_fleder": {
    name: "Vampire: Fleder",
    power: 4,
    ability: "muster",
    musterType: "vampire",
    img: "vampire_fleder",
    faction: "monster",
    type: 0
    , collected: false
  },
  "vampire_garkain": {
    name: "Vampire: Garkain",
    power: 4,
    ability: "muster",
    musterType: "vampire",
    img: "vampire_garkain",
    faction: "monster",
    type: 0
    , collected: false
  },
  "vampire_ekimmara": {
    name: "Vampire: Ekimmara",
    power: 4,
    ability: "muster",
    musterType: "vampire",
    img: "vampire_ekimmara",
    faction: "monster",
    type: 0
    , collected: false
  },
  "arachas": {
    name: "Arachas",
    power: 4,
    ability: "muster",
    musterType: "arachas",
    img: "arachas1",
    faction: "monster",
    type: 0
    , collected: false
  },
  "arachas2": {
    name: "Arachas",
    power: 4,
    ability: "muster",
    musterType: "arachas",
    img: "arachas2",
    faction: "monster",
    type: 0
    , collected: false
  },
  "arachas3": {
    name: "Arachas",
    power: 4,
    ability: "muster",
    musterType: "arachas",
    img: "arachas3",
    faction: "monster",
    type: 0
    , collected: false
  },
  "botchling": {
    name: "Botchling",
    power: 4,
    ability: null,
    img: "botchling",
    faction: "monster",
    type: 0
    , collected: false
  },
  "forktail": {
    name: "Forktail",
    power: 5,
    ability: null,
    img: "forktail",
    faction: "monster",
    type: 0
    , collected: false
  },
  "plague_maiden": {
    name: "Plague Maiden",
    power: 5,
    ability: null,
    img: "plague_maiden",
    faction: "monster",
    type: 0
    , collected: false
  },
  "griffin": {
    name: "Griffin",
    power: 5,
    ability: null,
    img: "griffin",
    faction: "monster",
    type: 0
    , collected: false
  },
  "werewolf": {
    name: "Werewolf",
    power: 5,
    ability: null,
    img: "werewolf",
    faction: "monster",
    type: 0
    , collected: false
  },
  "frightener": {
    name: "Frightener",
    power: 5,
    ability: null,
    img: "frightener",
    faction: "monster",
    type: 0
    , collected: false
  },
  "ice_giant": {
    name: "Ice Giant",
    power: 5,
    ability: null,
    img: "ice_giant",
    faction: "monster",
    type: 2
    , collected: false
  },
  "grave_hag": {
    name: "Grave Hag",
    power: 5,
    ability: null,
    img: "grave_hag",
    faction: "monster",
    type: 1
    , collected: false
  },
  /*"vampire_katakan": {
    name: "Vampire: Katakan",
    power: 5,
    ability: "muster",
 musterType: "vampire",
    img: "vampire_katakan",
    faction: "monster",
    type: 0
,collected:false  
},*/
  "crone_whispess": {
    name: "Crone: Whispess",
    power: 6,
    ability: "muster",
    musterType: "crone",
    img: "crone_whispess",
    faction: "monster",
    type: 0
    , collected: false
  },
  "crone_brewess": {
    name: "Crone: Brewess",
    power: 6,
    ability: "muster",
    musterType: "crone",
    img: "crone_brewess",
    faction: "monster",
    type: 0
    , collected: false
  },
  "crone_weavess": {
    name: "Crone: Weavess",
    power: 6,
    ability: "muster",
    musterType: "crone",
    img: "crone_weavess",
    faction: "monster",
    type: 0
    , collected: false
  },
  "arachas_behemoth": {
    name: "Arachas Behemoth",
    power: 6,
    ability: "muster",
    musterType: "arachas",
    img: "arachas_behemoth",
    faction: "monster",
    type: 2
    , collected: false
  },
  "fire_elemental": {
    name: "Fire Elemental",
    power: 6,
    ability: null,
    img: "fire_elemental",
    faction: "monster",
    type: 2
    , collected: false
  },
  "fiend": {
    name: "Fiend",
    power: 6,
    ability: null,
    img: "fiend",
    faction: "monster",
    type: 0
    , collected: false
  },
  "earth_elemental": {
    name: "Earth Elemental",
    power: 6,
    ability: null,
    img: "earth_elemental",
    faction: "monster",
    type: 2
    , collected: false
  },


  //nilfgaardian
  "emreis_emperor": {
    name: "Emhyr vas Emreis the Emperor",
    power: -1,
    ability: "emreis_leader1",
    img: "emhyr_emperor",
    faction: "nilfgaardian",
    type: 3
    , collected: false
  },
  "emreis_imperial": {
    name: "Emhyr vas Emreis the Imperial Majesty",
    power: -1,
    ability: "emreis_leader2",
    img: "emhyr_imperial",
    faction: "nilfgaardian",
    type: 3
    , collected: false
  },
  "emreis_relentless": {
    name: "Emhyr vas Emreis the Relentless",
    power: -1,
    ability: "emreis_leader3",
    img: "emhyr_relentless",
    faction: "nilfgaardian",
    type: 3
    , collected: false
  },
  "emreis_white": {
    name: "Emhyr vas Emreis the White Flame",
    power: -1,
    ability: "emreis_leader4",
    img: "emhyr_white",
    faction: "nilfgaardian",
    type: 3
    , collected: false
  },
  "tibor_eggebracht": {
    name: "test",
    power: 10,
    ability: "hero",
    img: "eggebracht",
    faction: "nilfgaardian",
    type: 1
    , collected: false
  },
  "letho_of_gulet": {
    name: "Letho of Gulet",
    power: 10,
    ability: "hero",
    img: "letho",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "morvran_voorhis": {
    name: "Morvran Voorhis",
    power: 10,
    ability: "hero",
    img: "voorhis",
    faction: "nilfgaardian",
    type: 2
    , collected: false
  },
  "menno_coehoorn": {
    name: "Menno Coehoorn",
    power: 10,
    ability: ["hero", "medic"],
    img: "menno",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "siege_technician": {
    name: "Siege Technician",
    power: 0,
    ability: "medic",
    img: "siege_tech",
    faction: "nilfgaardian",
    type: 2
    , collected: false
  },
  "etolian_auxiliary_archers1": {
    name: "Etolian Auxiliary Archers",
    power: 1,
    ability: "medic",
    img: "aux_archers1",
    faction: "nilfgaardian",
    type: 1
    , collected: false
  },
  "etolian_auxiliary_archers2": {
    name: "Etolian Auxiliary Archers",
    power: 1,
    ability: "medic",
    img: "aux_archers2",
    faction: "nilfgaardian",
    type: 1
    , collected: false
  },
  "albrich": {
    name: "Albrich",
    power: 2,
    ability: null,
    img: "albrich",
    faction: "nilfgaardian",
    type: 1
    , collected: false
  },
  "sweers": {
    name: "Sweers",
    power: 2,
    ability: null,
    img: "sweers",
    faction: "nilfgaardian",
    type: 2
    , collected: false
  },
  "nausicaa_cavalry_rider1": {
    name: "Nausicaa Cavalry Rider",
    power: 2,
    ability: "tight_bond",
    img: "nausicaa_cavalry_rider",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "nausicaa_cavalry_rider2": {
    name: "Nausicaa Cavalry Rider",
    power: 2,
    ability: "tight_bond",
    img: "nausicaa_cavalry_rider",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "nausicaa_cavalry_rider3": {
    name: "Nausicaa Cavalry Rider",
    power: 2,
    ability: "tight_bond",
    img: "nausicaa_cavalry_rider",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "vreemde": {
    name: "Vreemde",
    power: 2,
    ability: null,
    img: "vreemde",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "rotten_mangonel": {
    name: "Rotten Mangonel",
    power: 3,
    ability: null,
    img: "rotten_mangonel",
    faction: "nilfgaardian",
    type: 2
    , collected: false
  },
  "morteisen": {
    name: "Morteisen",
    power: 3,
    ability: null,
    img: "morteisen",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "puttkammer": {
    name: "Puttkammer",
    power: 3,
    ability: null,
    img: "puttkammer",
    faction: "nilfgaardian",
    type: 1
    , collected: false
  },
  "impera_brigade_guard1": {
    name: "Impera Brigade Guard",
    power: 3,
    ability: "tight_bond",
    img: "impera_brigade_guard",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "impera_brigade_guard2": {
    name: "Impera Brigade Guard",
    power: 3,
    ability: "tight_bond",
    img: "impera_brigade_guard",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "impera_brigade_guard3": {
    name: "Impera Brigade Guard",
    power: 3,
    ability: "tight_bond",
    img: "impera_brigade_guard",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "impera_brigade_guard4": {
    name: "Impera Brigade Guard",
    power: 3,
    ability: "tight_bond",
    img: "impera_brigade_guard",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "vanhemar": {
    name: "Vanhemar",
    power: 4,
    ability: null,
    img: "vanhemar",
    faction: "nilfgaardian",
    type: 1
    , collected: false
  },
  "vattier_de_rideaux": {
    name: "Vattier de Rideaux",
    power: 4,
    ability: "spy",
    img: "vattier",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "rainfarn": {
    name: "Rainfarn",
    power: 4,
    ability: null,
    img: "rainfarn",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "cynthia": {
    name: "Cynthia",
    power: 4,
    ability: null,
    img: "cynthia",
    faction: "nilfgaardian",
    type: 1
    , collected: false
  },
  "zerrikanian_fire_scorpion": {
    name: "Zerrikanian Fire Scorpion",
    power: 5,
    ability: null,
    img: "fire_scorpion",
    faction: "nilfgaardian",
    type: 2
    , collected: false
  },
  "young_emmisary1": {
    name: "Young Emissary",
    power: 5,
    ability: "tight_bond",
    img: "young_emissary1",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "young_emmisary2": {
    name: "Young Emissary",
    power: 5,
    ability: "tight_bond",
    img: "young_emissary2",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "renuald_aep_matsen": {
    name: "Renuald aep Matsen",
    power: 5,
    ability: null,
    img: "renauld",
    faction: "nilfgaardian",
    type: 1
    , collected: false
  },
  "siege_engineer": {
    name: "Siege Engineer",
    power: 6,
    ability: null,
    img: "siege_engineer",
    faction: "nilfgaardian",
    type: 2
    , collected: false
  },
  "cahir_mawr_dyffryn_aep_ceallach": {
    name: "Cahir Mawr Dyffryn aep Ceallach",
    power: 6,
    ability: null,
    img: "ceallach",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "fringilla_vigo": {
    name: "Fringilla Vigo",
    power: 6,
    ability: null,
    img: "vigo",
    faction: "nilfgaardian",
    type: 1
    , collected: false
  },
  "assire_var_anahid": {
    name: "Assire var Anahid",
    power: 6,
    ability: null,
    img: "assire_var_anahid",
    faction: "nilfgaardian",
    type: 1
    , collected: false
  },
  "shilard_fitz_oesterlen": {
    name: "Shilard Fitz-Oesterlen",
    power: 7,
    ability: "spy",
    img: "shilard",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "stefan_skellen": {
    name: "Stefan Skellen",
    power: 9,
    ability: "spy",
    img: "stefan_skellen",
    faction: "nilfgaardian",
    type: 0
    , collected: false
  },
  "heavy_zerrikanian_fire_scorpion": {
    name: "Heavy Zerrikanian Fire Scorpion",
    power: 10,
    ability: null,
    img: "heavy_fire_scorpion",
    faction: "nilfgaardian",
    type: 2
    , collected: false
  },
  "black_infantry_archer": {
    name: "Black Infantry Archer",
    power: 10,
    ability: null,
    img: "black_infantry_archer1",
    faction: "nilfgaardian",
    type: 1,
    collected: false
  },
  "black_infantry_archer2": {
    name: "Black Infantry Archer",
    power: 10,
    ability: null,
    img: "black_infantry_archer2",
    faction: "nilfgaardian",
    type: 1,
    collected: false
  }
}


// WEBPACK FOOTER //
// ./src/utils/cards.js